<template>
  <div>
    <div v-if="isLoading">
      <OtherLoading />
    </div>
    <div v-else>
      <div class="d-flex justify-content-between align-items-center">
        <InputText
          v-model="filter.search"
          type="text"
          faIcon="search"
          className="my-3 bg-second w-50"
          placeholder="ค้นหา Serial"
          @onClickIcon="handleSearch"
          @onEnter="handleSearch"
        />
        <HeaderPanel
          title=""
          :filter="filter"
          @search="handleSearch"
          @clear="clearFilter"
        >
          <template v-slot:filter-option>
            <div class="px-2">
              <div class="mb-2">
                <InputSelect
                  title="สาขา"
                  v-model="filter.filter_branch_id"
                  textField="branch_name"
                  valueField="branch_id"
                  :options="branchList"
                  @onDataChange="handleSelectBranch"
                >
                  <template v-slot:option-first>
                    <b-form-select-option :value="0" disabled
                      >-- สาขา --</b-form-select-option
                    >
                  </template>
                </InputSelect>
              </div>
              <div class="mb-2">
                <InputSelect
                  title="Stock"
                  v-model="filter.filter_stock_type_id"
                  textField="name"
                  valueField="id"
                  :options="stockList"
                  :disabled="!filter.filter_branch_id"
                  @onDataChange="(val) => (filter.filter_stock_type_id = val)"
                >
                  <template v-slot:option-first>
                    <b-form-select-option :value="0" disabled
                      >-- Stock --</b-form-select-option
                    >
                  </template>
                </InputSelect>
              </div>
            </div>
          </template>
        </HeaderPanel>
      </div>
      <b-table
        responsive
        striped
        hover
        :fields="fields"
        :items="items"
        :busy="isBusy"
        show-empty
        empty-text="No matching records found"
        class="table-main"
        @sort-changed="storeSorting"
        :sort-by.sync="filter.sortBy"
        no-local-sorting
        :sort-desc.sync="filter.sortDesc"
      >
        <template v-slot:cell(name)="{ item }">
          <div
            class="text-link"
            @click="$router.push(`/product/detail/${item.product_id}`)"
          >
            {{ item.name }}
          </div>
          <span class="text-gray">{{ item.barcode }}</span>
        </template>
        <template v-slot:cell(price)="{ item }">
          {{ item.price | numeral("0,0.00") }}
        </template>
        <template v-slot:table-busy>
          <div class="text-center text-black my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong class="ml-2">Loading...</strong>
          </div>
        </template>
      </b-table>
      <Pagination
        @handleChangeTake="handleChangeTake"
        :pageOptions="pageOptions"
        :filter="filter"
        :rows="rows"
        @pagination="pagination"
      />
    </div>
  </div>
</template>
<script>
import OtherLoading from "@/components/loading/OtherLoading";
import HeaderPanel from "@/components/HeaderPanel.vue";
import { mapGetters } from "vuex";
export default {
  components: {
    OtherLoading,
    HeaderPanel,
  },
  props: {
    branchList: {
      required: false,
    },
  },
  computed: {
    ...mapGetters({
      branchId: "getBranchId",
    }),
  },
  name: "Product",

  data() {
    return {
      isLoading: false,
      filter: {
        search: "",
        page: 1,
        take: 10,
        branch_id: "",
        sortBy: "",
        sortDesc: false,
        SortType: true,
        SortColumnId: 0,
        product_id: this.$route.params.id,
        filter_stock_type_id: 0,
        filter_branch_id: 0,
      },
      id: this.$route.params.id,
      items: [],
      isBusy: false,
      rows: 0,
      pageOptions: [
        { value: 5, text: "5 / page" },
        { value: 10, text: "10 / page" },
        { value: 30, text: "30 / page" },
        { value: 50, text: "50 / page" },
        { value: 100, text: "100 / page" },
      ],
      fields: [
        {
          key: "serial",
          label: "Serial",
          thClass: "w-1",
        },
        {
          key: "branch_name",
          label: "Branch Name",
          sortable: true,
          thClass: "w-1",
        },

        {
          key: "branch_short_name",
          label: "Branch Short Name",
          sortable: true,
          thClass: "w-1",
        },
        {
          key: "stock_type_name",
          label: "Stock",
          sortable: true,
          thClass: "w-1",
        },
          {
          key: "custom_1",
          label: "",
          thClass: "w-1",
        },
        {
          key: "custom_2",
          label: "",
          thClass: "w-1",
        },
        {
          key: "custom_3",
          label: "",
          thClass: "w-1",
        },
        {
          key: "price",
          label: "ราคา ",
          thClass: "w-1",
          sortable: true,
        },
      ],

      stockList: [],
    };
  },
  async created() {
    await this.getList();
  },
  methods: {
    async getList() {
      this.isLoading = true;
      this.isBusy = true;
      this.filter.branch_id = this.branchId;
      const res = await this.axios.post(
        `${this.$baseUrl}/product/get_related_product_serial_stock/${this.id}`,
        this.filter
      );
      if (res.result == 1) {
        if (res.detail.variants.length) {
          this.options = res.detail.variants;
        
          let variant = await this.$store.dispatch(
            "transformVariantData",
            res.detail.variants
          );

     
          for (const element of res.detail.related_product_stock) {
            for (const opt of element.options) {
              let key = variant.find((e) => e.id == opt.id);

              element[key.key] = opt.name;
            }
          }
          let i = 4;

          for (const element of res.detail.variants) {
            this.fields[i].label = element.attribute.name;
            this.fields[i].key = element.attribute.name;
            i++;
          }
        }
        this.isLoading = false;
        this.items = res.detail.related_product_stock;
        this.rows = res.detail.count;
         this.fields = this.fields.filter((el) => el.label);
      }

      this.isBusy = false;
    },

    async handleSearch() {
      this.filter.page = 1;
      await this.getList();
    },
    pagination(page) {
      this.filter.page = page;

      this.getList();
    },
    handleChangeTake(value) {
      this.filter.page = 1;
      this.filter.take = value;

      this.getList();
    },
    storeSorting(ctx) {
      let id = 0;

      switch (ctx.sortBy) {
        case "branch_name":
          id = 1;
          break;
        case "branch_short_name":
          id = 2;
          break;
        case "stock_type_name":
          id = 3;
          break;
        case "price":
          id = 4;
          break;
        default:
          id = 0;
          break;
      }

      if (
        this.filter.SortType &&
        !ctx.sortDesc &&
        this.filter.SortColumnId == id
      ) {
        this.filter.SortColumnId = 0;
        this.filter.sortBy = "";
        this.filter.sortDesc = false;
      } else {
        this.filter.SortColumnId = id;
        this.filter.SortType = ctx.sortDesc;
        this.filter.sortBy = ctx.sortBy;
        this.filter.sortDesc = ctx.sortDesc;
      }

      this.getList();
    },
    clearFilter() {
      this.filter = {
        search: "",
        page: 1,
        take: 10,
        branch_id: "",
        sortBy: "",
        sortDesc: false,
        SortType: true,
        SortColumnId: 0,
        product_id: this.$route.params.id,
        filter_stock_type_id: 0,
        filter_branch_id: 0,
      };
      this.getList();
    },
    async handleSelectBranch(val) {
      this.filter.filter_branch_id = val;
      this.filter.filter_stock_type_id = 0;
      await this.getStockList();
    },
    async getStockList() {
      const data = await this.axios(
        `${this.$baseUrl}/inventory/GetActiveStockType/${this.filter.filter_branch_id}/${this.id}`
      );
      this.stockList = data.detail;
    },
  },
};
</script>
